import request from '@/utils/request'


export function upload(data) {
  return request({
    url: '/index/upload/upProject',
    method: 'post',
    data
  })
}
export function uploadChunks(data) {
  return request({
    url: '/index/upload/uploadChunks',
    method: 'post',
    data
  })
}


export function getMyProject(data) {
  return request({
    url: '/index/upload/myupmsg',
    method: 'post',
    data
  })
}